import { FC } from 'react';
import { useRouter } from 'next/router';

import { Slideout, SlideoutCommonProps, SuccessIcon } from 'components/design-system/Slideout';
import { pageRoutes } from 'lib/routes';
import { extendUrlByQueries } from 'lib/url_helpers';

export const AuctionSubmittedSlideoutTestIds = {
  container: 'auction-submitted-slideout-container'
};

export type AuctionSubmittedSlideoutProps = SlideoutCommonProps;

export const AuctionSubmittedSlideout: FC<AuctionSubmittedSlideoutProps> = ({ ...props }) => {
  const { push } = useRouter();
  const goToPendingListings = () => {
    props.closeModal?.();
    push(extendUrlByQueries(pageRoutes.sellerInventory, { status: 'Pending' }));
  };

  return (
    <Slideout
      {...props}
      title
      data-testid={AuctionSubmittedSlideoutTestIds.container}
      onClickPrevious={undefined}
      submit={{ title: 'View pending listings', onClick: goToPendingListings }}
    >
      <div className='text-primary d-flex px-3 text-center flex-column align-items-center riforma-regular'>
        <SuccessIcon />
        <h6 className='fs-24px mb-5 opacity-90 riforma-medium letter-spacing-007'>
          Your auction request was submitted
        </h6>
        <div className='opacity-60 letter-spacing-006'>
          The auction will go live in the next drop after approval, typically 1-2 business days. If there are any
          questions, the auction team will reach out.
        </div>
      </div>
    </Slideout>
  );
};
